import React, { Fragment, useState } from "react";
import useOtherDocuments from "../../lib/useOtherDocuments";
import { useDeleteOtherDocs } from "../../lib/useDeleteOtherDocs";
import { CiFileOn } from "react-icons/ci";
import { RiDeleteBin6Line } from "react-icons/ri";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Worker, Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';

const ViewOtherDocs = () => {
  const { data, isLoading, error } = useOtherDocuments();
  const deleteMutation = useDeleteOtherDocs();

  const [isDeleteConfirmationVisible, setDeleteConfirmationVisible] = useState(false);
  const [selectedDocumentToDelete, setSelectedDocumentToDelete] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const [deleteError, setDeleteError] = useState(null);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [pdfError, setPdfError] = useState(null); // For error handling in the viewer

  const toggleDeleteConfirmation = () => {
    setDeleteConfirmationVisible(!isDeleteConfirmationVisible);
  };

  const handleDocumentSelection = (document) => {
    setSelectedDocumentToDelete(document);
    toggleDeleteConfirmation();
  };

  const handleDelete = () => {
    if (selectedDocumentToDelete) {
      const documentToDelete = {
        otherDocuments: [
          {
            _id: selectedDocumentToDelete._id,
            name: selectedDocumentToDelete.name,
            fileUrl: selectedDocumentToDelete.fileUrl,
          },
        ],
      };
      setIsDeleting(true);
      deleteMutation.mutate(documentToDelete, {
        onSuccess: () => {
          setSelectedDocumentToDelete(null);
          toggleDeleteConfirmation();
        },
        onError: (error) => {
          console.error("Error deleting document:", error);
          setDeleteError(
            error.response?.data?.message ||
              "An error occurred while deleting the document."
          );
        },
        onSettled: () => {
          setIsDeleting(false);
        },
      });
    }
  };

  const handleViewPdf = (url) => {
    setPdfUrl(url);
    setShowModal(true);
    setPdfError(null); // Reset any previous error
  };

  const closeModal = () => {
    setShowModal(false);
    setPdfUrl(null);
    setPdfError(null); // Reset error when closing modal
  };

  if (isLoading) {
    return (
      <div className="sta-card">
        {[...Array(2)].map((_, index) => (
          <div className="cards" key={index}>
            <div className="in">
              <Skeleton circle height={40} width={40} />
              <div className="size">
                <Skeleton height={20} width={100} />
                <Skeleton height={16} width={200} />
              </div>
            </div>
            <div className="mark">
              <Skeleton height={30} width={60} />
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (error) return <div>Error: {error.message}</div>;

  const otherDocs = data?.data?.otherDocuments || [];

  return (
    <Fragment>
      {showModal && pdfUrl && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <Worker workerUrl={`https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js`}>
              <Viewer
                fileUrl={pdfUrl}
                onLoadError={(err) => {
                  setPdfError("Error loading PDF");
                  console.error("PDF Load Error:", err);
                }}
              />
            </Worker>
            {pdfError && <div className="error-message">{pdfError}</div>}
          </div>
          <button className="close-btn" onClick={closeModal}>
            Close
          </button>
        </div>
      )}

      {isDeleteConfirmationVisible && (
        <div className="delete-overlay">
          <div className="delete-overlay-content">
            <h2>Delete Confirmation</h2>
            <p>Are you sure you want to delete this document?</p>
            <div className="btn-group">
              <button onClick={toggleDeleteConfirmation}>No</button>
              <button onClick={handleDelete} disabled={isDeleting}>
                {isDeleting ? "Deleting..." : "Yes"}
              </button>
            </div>
            {deleteError && <p>Error: {deleteError}</p>}
          </div>
        </div>
      )}

      <div className="sta">
        {otherDocs.length > 0 ? (
          <div className="sta-card">
            {otherDocs.map((document, index) => (
              <div className="cards" key={index}>
                <div className="in">
                  <CiFileOn className="file" />
                  <div className="size">
                    <h4>{document.name}</h4>
                    <p>200 KB – 100% Uploaded</p>
                  </div>
                </div>
                <div className="mark">
                  <button onClick={() => handleDocumentSelection(document)}>
                    <RiDeleteBin6Line />
                  </button>
                  <button onClick={() => handleViewPdf(document.fileUrl)}>
                    View
                  </button>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div style={{fontFamily:"Montserrat", fontSize:"16px", fontWeight:"500", color:"#000000"}}>No other docs available</div>
        )}
      </div>
    </Fragment>
  );
};

export default ViewOtherDocs;
